import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { BackfillDealsRequest } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/BackfillDeals.pb'
import { BackfillDealsResponse } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/BackfillDeals.pb'

export const backfillDeals = (request: BackfillDealsRequest, options?: CashRequestOptions) =>
  post<BackfillDealsRequest, BackfillDealsResponse>('/2.0/cash/backfill-deals', request, {
    ...options,
    rejectOnError: true,
  })
